import { formatISO } from 'date-fns';
type DateLike = Date | number | string;

/**
 * 日付をISO形式（yyyy-MM-dd）にフォーマットします。
 *
 * @param date - フォーマットする日付
 * @returns フォーマットされた日付文字列
 */
export function formatISODate(date: DateLike) {
  return formatISO(date, {
    representation: 'date'
  });
}